import {forwardRef, useImperativeHandle, useRef} from "react";
import {useSetState} from "ahooks";
import {SActionBtn, SDrawerOrModal, SLowcodeList, SMessage, STableActions} from "shj-components";
import {message} from "antd";

import {generalStandardDelete, getGeneralStandardList} from "@/services/product.ts";
import {config} from './config.tsx'
import {AddOrEditStandard} from "./addOrEdit.tsx";

type IProps = {
  genItemId?: string
  readOnly?: boolean
}

export const StandardTable = forwardRef((props: IProps, ref) => {
  const {genItemId, readOnly = false} = props;
  const listRef = useRef()
  const editRef = useRef()

  const [state, setState] = useSetState({visible: false, record: {}, btnLoading: false})

  useImperativeHandle(ref, () => {
    return {getData: () => listRef.current?.getDataSource()}
  })

  const fetchList = () => {
    console.log('genItemId',genItemId)
    if (!genItemId) return Promise.reject()
    return new Promise((resolve, reject) => {
      getGeneralStandardList({genItemId, searchFlag: true}).then(res => {
        resolve({records: res})
      }).catch(reject)
    })
  }

  const onAdd = () => onEdit()

  const onEdit = (record = {}) => {
    setState({visible: true, record})
  }

  const onDel = (record) => {
    SMessage.confirm({
      onOk: () => {
        if (!genItemId) {
          const data = listRef.current?.getDataSource();
          listRef.current?.updateDataSource(data.filter(item => item.key !== record.key))
          return Promise.resolve()
        } else {
          return generalStandardDelete(record.id).then((res: any) => {
            message.success(res.message || '操作成功');
            listRef.current?.reload()
          })
        }
      },
    });
  }

  const extensions = {
    request: {fetchList},
    events: {onAdd},
    customRender: {
      actionRender(_, record: Record<string, any>) {
        return <STableActions>
          {readOnly ? <SActionBtn onClick={() => onEdit(record)}>详情</SActionBtn>
              : [<SActionBtn onClick={() => onEdit(record)}>编辑</SActionBtn>,
                <SActionBtn danger onClick={() => onDel(record)}>删除</SActionBtn>]}

        </STableActions>
      }
    }
  }

  const onCancel = () => {
    setState({visible: false, record: {}})
  }

  const onSubmit = () => {
    editRef.current?.onFinish()
  }

  const onSubmitOk = (values) => {
    if (!genItemId) {
      const data = listRef.current?.getDataSource().filter(item => item.key !== values.key);
      listRef.current?.updateDataSource([...data, values])
    } else {
      listRef.current?.reload()
    }
    onCancel()
  }

  return <>
    <SLowcodeList searchMode={'group'} ref={listRef} config={{...config, footer: readOnly ? [] : config.footer}} {...extensions} />
    <SDrawerOrModal title={props.readOnly ? '标配详情' : ((state.record.id ? '编辑' : '新增') + '标配')}
                    width={600}
                    open={state.visible}
                    onOk={onSubmit}
                    antdProps={props.readOnly ? { footer: null } : {}}
                    loading={state.btnLoading}
                    onCancel={onCancel}>
      {state.visible &&
          <AddOrEditStandard record={state.record} {...props} ref={editRef} fn={onSubmitOk}
                             setLoading={(btnLoading: boolean) => setState({btnLoading})}/>}
    </SDrawerOrModal>
  </>
})